import React from 'react';
import Navbar from '../components/Navbar';

const Contact = () => {
	return (
        <div className="bodystyle">
            <div id="everything">
                <Navbar />
				<div style={{textAlign:'center'}}>
					<iframe title="Contact Form" src="https://docs.google.com/forms/d/e/1FAIpQLSfFNsWYZxFtt8mfZXumq_vFid0nUlT0a_kvT7RbZexAYuReBA/viewform?embedded=true" width="640" height="709" frameBorder="0" marginHeight="0" marginWidth="0">Loading…</iframe>
				</div>
			</div>
		</div>
	);
};

export default Contact;

